import { render } from "./MyExpense.vue?vue&type=template&id=37b31650&scoped=true"
import script from "./MyExpense.vue?vue&type=script&lang=js"
export * from "./MyExpense.vue?vue&type=script&lang=js"

import "./MyExpense.vue?vue&type=style&index=0&id=37b31650&scoped=true&lang=css"

import exportComponent from "/home/umut/Desktop/tm-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37b31650"]])

export default __exports__